export const useRootStore = defineStore("root", () => {
  const errors = ref({});
  const loading = ref(false);
  const token = ref(null);
  const auth = ref({
    message: null,
  });

  const headers = computed(() => {
    return {
      "WWW-Authenticate": "Bearer",
      Authorization: token.value
        ? token.value
        : localStorage.getItem("accessToken"),
    };
  });

  const cerrarApp = () => {
    usuario.value = null;
  };

  const loadingCount = ref(0);

  const toggleLoading = (bol = true) => {
    if (bol) {
      loadingCount.value++;
    } else {
      if (loadingCount.value > 0) {
        loadingCount.value--;
      }
    }
    loading.value = loadingCount.value > 0;
  };

  const setErrors = (data) => {
    if (typeof data === "string") {
      errors.value.message = data;
    } else {
      errors.value = data;
    }
  };

  const clearErrors = () => {
    errors.value = { carta: {} };
  };

  const setAuthMessage = (data) => {
    auth.value.message = data;
  };

  const setToken = (data) => (token.value = data);

  const cerrarSesion = async () => {
    return await axios.get("/api/auth/logout", null, {
      headers: headers.value,
    });
  };

  return {
    errors,
    loading,
    token,
    auth,
    headers,
    cerrarApp,
    toggleLoading,
    setErrors,
    clearErrors,
    setAuthMessage,
    setToken,
    cerrarSesion,
  };
});

export default useRootStore;
